export default __webpack_public_path__ + "static/media/NFT2.760ac67c.png";